import { render, staticRenderFns } from "./AddProductFromWarehouse.vue?vue&type=template&id=7141b2d6&scoped=true"
import script from "./AddProductFromWarehouse.vue?vue&type=script&lang=js"
export * from "./AddProductFromWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7141b2d6",
  null
  
)

export default component.exports